import { TylTranslation } from '../../../shared-components/models/tyl-translation.model';
import { EFormTemplate } from '../../../shared-components/e-forms/e-form-template.model';

export class BehaviorLetter {
    Id: number;
    IncidentId: number;
    StudentId: number;
    TemplateId: number;
    StudentNumberIdentifier: string;
    FirstName: string;
    LastName: string;
    Gender: string;
    GradeIdentifier: string;
    GradeLevelId: number;
    SchoolId: number;
    AYIdentifier: string;
    EventName: string;
    TemplateName: string;
    FormData: string;
    base64PDF: string;
    AddedBy: number;
    AddedByName: string;
    AddedOn: Date;
    LastUpBy: number;
    LastUpOn: Date;
    DelStatus: boolean;
    Selected: boolean = false;
    // V9 Only
    DocId: number;
    FileType: string;
    DocTypeId: number;
	letterOnlyForNonResidentParent = false;

}

export class GenerateMailingLabels {
    studentIds: number[] = [];
    householdParents = false;
    nonresidentParents = false;
    onlyIfRequested = false;
    printOnly = true;
    message = '';
    subject = 'Behavior Letter Notification';
    translations: TylTranslation[] = [];
    action = '';
    steps: number;
    behaviorLetterTemplate: EFormTemplate;
    behaviorLetterEmailAddress: BehaviorLetterEmailAddress[] = [];
}

export class BehaviorLetterEmailAddress {
    ID: number;
    Student_ID: string;
    StudentName: string;
    EmailId: string;
    EmailType: string;
    RequestingMail: boolean;
    SiteYear: string;
    ParentName: string;
}

